import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'

// Vant组件
require("@/vant")

// 公共样式
require('@/assets/styles/default.less')

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js